module.exports = __webpack_public_path__ + "static/img/225_TO8_1964_og.44659b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/225_TO8_1964_og.jpg
// module id = JWKb
// module chunks = 0